import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/plugin/article/list',
    name: 'articleList',
    component: () => import('@/views/plugin/article/list'),
    meta: {
      title: i18n.t('router.article.article_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/plugin/article/category',
    name: 'articleCategory',
    component: () => import('@/views/plugin/article/category'),
    meta: {
      title: i18n.t('router.article.article_category'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/article.js